import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Container, Label, Modal, ModalBody, ModalHeader, Row
} from "reactstrap";

import i18n from 'i18n';
import { toast, Zoom,ToastContainer } from "react-toastify";
import "toastr/build/toastr.min.css";

import { Field, Form, Formik } from "formik";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
//Import Common Component

import {
  DeleteModal,
  ErrorModal,
  RavenAgTable
} from "../../../components/Common/CombinedComponents";

import { displayNone, getInitValue, getInitValueDate, getTitleValue } from "../../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import PageModalFooter from "../../../components/Common/PageComponents/PageModalFooter";
import RavenFormikField from "../../../components/Common/RavenFormikField";
//Translate
import { Base64 } from "js-base64";
import { withTranslation } from "react-i18next";
//Actions
import {
  addNewUserDefinition, deleteUserDefinition, getUserDefinitionsByUserName, getUserStatusDefinitions, updateUserDefinition, userDefinitionsApiError
} from "../../../store/actions";

import { post as GenerateClientId, post as GenerateClientSecret } from "../../../helpers/api_helper/Authentication/authenticationApiHelper";
import { CheckDuplicateUser, GeneratePassword } from "../../../helpers/api_helper/Authentication/authenticationApiHelper";
import * as url from "../../../helpers/url_helper/url_helper";
const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
const startsWithSpecialChars = new RegExp(/^'?\p{L}+(?:[' ]\p{L}+)*'?$/u)
const phoneRegex = "^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$";
let internalUser = true;
let clientPanel = false;

class userDefinition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      modal: false,
      record: "",
      deleteModal: false,
      errorModal: false,
      addAnother: false,
      isDetail: false,
      isEdit: false,
      passDisabled: false,
      encode : false,
      recordcolumns: [
        {
          headerName: this.props.t("userName"),
          field: "userName",
          tooltipField: "description",
          minWidth: 200,
        },
        {
          headerName: this.props.t("firstName"),
          field: "firstName",
          minWidth: 200,
        },
        {
          headerName: this.props.t("lastName"),
          field: "lastName",
          minWidth: 200,
        },
        {
          headerName: this.props.t("phone"),
          field: "phone",
          minWidth: 200,
        },
        {
          headerName: this.props.t("email"),
          field: "email",
          minWidth: 200,
        },
        {
          headerName: this.props.t("address"),
          field: "address",
          minWidth: 200,
        },
      ],

    };

    this.toggle = this.toggle.bind(this);
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
    this.handleAddRecordClick = this.handleAddRecordClick.bind(this);
    this.handleEditRecordClick = this.handleEditRecordClick.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.handleGeneratePassword = this.handleGeneratePassword.bind(this);
    this.handleGenerateClientId = this.handleGenerateClientId.bind(this);
    this.handleGenerateClientSecret = this.handleGenerateClientSecret.bind(this);
    this.onConfirmModal = this.onConfirmModal.bind(this);


  }

  //#region Base Operations
  componentDidMount() {
    this.props.apiError("");
    const { recordList, onGetRecordList, userStatusDefList,
      onGetUserStatusList } = this.props;
    onGetUserStatusList();
    const username = localStorage.getItem("username");
    this.setState({ userStatusDefList });
    setTimeout(() => {
      if (recordList && !recordList.length) {
        onGetRecordList(username);
      }
      this.setState({ recordList });
    }, 100);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
  }

  //#endregion

  //#region Cruid Operations

  handleDetailClick = values => {
    values.dateOfBirth = moment(values.dateOfBirth).format(
      "YYYY-MM-DD"
    );
    this.setState({
      record: values,
      addAnother: false,
      isDetail: true,
      isEdit: true,
    });
    clientPanel=true;
    this.toggle();
  };

  handleAddRecordClick = () => {
    this.setState({ record: "", isEdit: false });
    clientPanel=true;
    this.toggle();
  };

  handleEditRecordClick = args => {
    args.dateOfBirth = moment(args.dateOfBirth).format(
      "YYYY-MM-DD"
    );
    if(!args.encode && args.clientSecret != null){
      args.clientSecret = Base64.decode(args.clientSecret);
      args.encode=true;
    }
   
    clientPanel=false;
    this.setState({
      record: args,
      addAnother: false,
      isEdit: true,
    });
    internalUser=true;
    
    this.toggle();
  };

  handleDeleteRecordClick = record => {
    const deleteUser = {
      guid: record.guid,
      userName: record.userName,
    };
    this.setState({ record: deleteUser });
    this.setState({ deleteModal: true });
  };

  handleValidRecordSubmit = values => {


    const { onAddRecord, onUpdateRecord, recordList } = this.props;
    const { isEdit, record } = this.state;
    values.dateOfBirth = moment(values.dateOfBirth).format(
      "YYYY-MM-DD"
    );
    let temp = values.firstName.split(' ');
    values.firstName = temp[0];
    values.middleName = temp[1] ?? "";
    values.userName = values.email;
    values.activationStatus = true; 
    values.merchantGuid = recordList[0].merchantGuid; 

    if (isEdit) {
      let rec = recordList.filter(x => x.guid == record.guid);
      rec[0].userName = values.userName;
      rec[0].firstName = values.firstName;
      rec[0].middleName = values.middleName;
      rec[0].dateOfBirth = values.dateOfBirth;
      rec[0].lastName = values.lastName;
      rec[0].phone = values.phone;
      rec[0].address = values.address;
      rec[0].systemUserStatusDefinitionGuid = values.systemUserStatusDefinitionGuid;
      rec[0].password = values.password;
      rec[0].photoPath = "string";   
      onUpdateRecord(rec[0]);
    } else {
      onAddRecord(values);
    }

    !this.state.addAnother && this.toggle();
  };

  handleDeleteRecord = () => {

    const { onDeleteRecord } = this.props;
    const { record } = this.state;
    if (record.guid !== undefined) {
      onDeleteRecord(record.guid);
      this.setState({ deleteModal: false });
    }
  };
  //#endregion

  //#region Dom Elements Design


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));

    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }

  handleGeneratePassword(setFieldValue) {
    new Promise((resolve, reject) => {
      GeneratePassword(url.GENERATE_PASSWORD)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error.text != undefined) {
            setFieldValue("password", error.text)
            toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
          }
        })
    })
  }

  handleGenerateClientId(values,setFieldValue,fromhandleSecret) {
    let req = {
      Guid: values.record.guid,
      UserName: values.record.userName,
      AccessToken: localStorage.getItem("accessToken")
    }
    new Promise(() => {
      GenerateClientId(url.GENERATE_CLIENT_ID, req)
        .then((res) => {
          values.record.clientId=res.clientId;
          setFieldValue("clientId", res.clientId)
          toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
          if(fromhandleSecret){
            this.handleGenerateClientSecret(values,setFieldValue);
          }
        })
        .catch((error) => {
          if (error.text != undefined) {
            console.log("handleGenerateClientId err",error)
          }
        })
    })
  }

  handleGenerateClientSecret(values,setFieldValue) {
    if(values.record.clientId==null){
      this.handleGenerateClientId(values,setFieldValue,true);
    }
    let req = {
      Guid: values.record.guid,
      UserName: values.record.userName,
      AccessToken: localStorage.getItem("accessToken"),
      AuthenticationClientId: values.record.clientId
    }
    new Promise(() => {
      GenerateClientSecret(url.GENERATE_CLIENT_SECRET,req)
        .then((res) => {
          values.record.clientSecret=res.secret;
           setFieldValue("clientSecret", Base64.decode(res.secret))
           toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
        })
        .catch((error) => {
          if (error.text != undefined) {
            console.log("handleGenerateClientSecret err",error)
          }
        })
    })
  }


  onConfirmModal(){
    this.setState({ successModal: false });
  }
  //#endregion

  render() {
    const { recordList } = this.props;
    const record = this.state.record;
    const error = this.state.error;
    const { deleteModal, recordcolumns } = this.state;
    this.props.recordList.sort((a, b) => a.userName.localeCompare(b.userName));
    this.props.userStatusDefList.sort((a, b) => a.name.localeCompare(b.name));

    return (
      <React.Fragment>
        <DeleteModal
          record={record}
          show={deleteModal}
          onDeleteClick={this.handleDeleteRecord}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined })} />)}
        <ToastContainer />
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <RavenAgTable
                      onAddClick={this.handleAddRecordClick}
                      onEditClick={this.handleEditRecordClick}
                      onDetailClick={this.handleDetailClick}
                      onDeleteClick={this.handleDeleteRecordClick}
                      breadCrumbTitle={this.props.t("userManagement")}
                      breadCrumbItem={this.props.t("userDefinition")}
                      actionItems={true}
                      exportOption={true}
                      recordcolumns={recordcolumns}
                      recordList={recordList}

                    />
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                      onClose={this.toggleModalClose}
                      size="xl"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {
                          getTitleValue(this, "userDefinition")
                        }

                      </ModalHeader>
                      <ModalBody>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            record: record,
                            userName: getInitValue(record, record.userName),
                            email: getInitValue(record, record.email),
                            firstName: getInitValue(record, record.firstName),
                            lastName: getInitValue(record, record.lastName),
                            dateOfBirth: getInitValueDate(record, record.dateOfBirth),
                            phone: getInitValue(record, record.phone),
                            systemUserStatusDefinitionGuid: getInitValue(record, record.systemUserStatusDefinitionGuid),
                            address: getInitValue(record, record.address),
                            password: getInitValue(record, record.password),
                            qrString: getInitValue(record, record.qrString),
                            photoPath: getInitValue(record, record.photoPath),
                            clientId: getInitValue(record, record.clientId),
                            clientSecret: getInitValue(record, record.clientSecret),
                            merchantGuid: getInitValue(record, record.merchantGuid),
                            encode : this.state.encode,
                          }}
                          validationSchema={Yup.object().shape({
                            userName: Yup.string()
                              .max(50, this.props.t("maxLengthError").format("50"))
                              .required(this.props.t("mustBe"))
                              .test("checkUser", this.props.t("userNameRegistered"),
                                function (userName, record) {
                                  let guid = record?.parent?.record?.guid != null ? record.parent.record.guid : 0
                                  let checkUserVm = {
                                    guid: guid,
                                    CheckObject: userName,
                                    CheckType: 1
                                  };
                                  return new Promise((resolve, reject) => {
                                    CheckDuplicateUser(url.CHECK_DUPLICATE_USER, checkUserVm)
                                      .then((res) => {
                                        if(res.checkType==1){
                                          resolve(res.result)
                                        }
                                      })
                                      .catch((error) => {
                                        if (error.response.data.content === "The username has already been taken.") {
                                          resolve(false);
                                        }
                                      })
                                  })
                                }
                              ),
                            email: Yup.string()
                              .max(50, this.props.t("maxLengthError").format("50"))
                              .required(this.props.t("mustBe"))
                              .test("checkEmail", this.props.t("emailRegistered"),
                                function (email, record) {
                                  let guid = record?.parent?.record?.guid != null ? record.parent.record.guid : 0
                                  let checkUserVm = {
                                    guid: guid,
                                    CheckObject: email,
                                    CheckType: 2
                                  };
                                  return new Promise((resolve, reject) => {
                                    CheckDuplicateUser(url.CHECK_DUPLICATE_USER, checkUserVm)
                                      .then((res) => {
                                        if(res.checkType==2){
                                          resolve(res.result)
                                        }
                                      })
                                      .catch((error) => {
                                        if (error.response.data.content === "The email has already been taken.") {
                                          resolve(false);
                                        }
                                      })
                                  })
                                }
                              )
                              .matches(emailRegex,
                                this.props.t("emailadressInvalid")),
                            firstName:
                              Yup.string()
                                .required(this.props.t("mustBe"))
                                .matches(/^[^.]*$/, this.props.t("noperiod"))
                                .matches(startsWithSpecialChars,
                                  this.props.t("nosymbol"))
                                .max(50, this.props.t("maxLengthError").format("50")),
                            lastName:
                              Yup.string()
                                .required(this.props.t("mustBe"))
                                .matches(/^[^.]*$/, this.props.t("noperiod"))
                                .matches(startsWithSpecialChars,
                                  this.props.t("nosymbol"))
                                .max(50, this.props.t("maxLengthError").format("50")),
                            internal: Yup.boolean(),
                            external: Yup.boolean(),
                            phone: Yup.string()
                              .strict(true)
                              .required(this.props.t("mustBe"))
                              .max(11, this.props.t("maxLengthError").format("11"))
                              .matches(phoneRegex,
                                this.props.t("phoneNumberInvalid")),
                            dateOfBirth: Yup.date()
                              .typeError(this.props.t("invalidBirthDate"))
                              .required(this.props.t("mustBe"))
                          })}
                          onSubmit={(values) => {
                            this.handleValidRecordSubmit(values);
                          }}
                        >
                          {({ errors, status, touched,values, setFieldValue }) => (
                            <Form>
                              <fieldset disabled={this.state.isDetail}>
                                <Row>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"userName"}
                                        label={"userName"}
                                        type="text"
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"email"}
                                        label={"email"}
                                        type="text"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"firstName"}
                                        label={"name"}
                                        type="text"
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"lastName"}
                                        label={"surname"}
                                        type="text"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"dateOfBirth"}
                                        label={"birthDate"}
                                        type="date"
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={6} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"phone"}
                                        label={"phoneNumber"}
                                        type="text"
                                      />
                                    </div>
                                  </Col>
                                  <div style={{ display: displayNone(clientPanel) }}>
                                  <Label className="form-label">
                                    {this.props.t("userType")}
                                  </Label>
                                  <div role="group" aria-labelledby="my-radio-group" className="form-control" style={{ maxWidth: "1110px", marginLeft: "10px" }}>
                                    <Row>
                                      <Col lg={3} className="col-3">
                                        <RavenFormikField
                                          errors={errors}
                                          touched={touched}
                                          name={"internal"}
                                          label={"userTypeInternal"}
                                          type="checkbox"
                                          checked={internalUser}
                                          disabled={this.state.passDisabled}
                                          onChange={(e) => {
                                            internalUser = true;
                                            setFieldValue("internal", internalUser)
                                          }
                                          }
                                          setFieldValue={setFieldValue}
                                        />
                                      </Col>
                                      <Col lg={12} className="col-12" style={{ marginTop: "3px",display: displayNone(internalUser)}}>
                                        <p>{""}</p>
                                        <div
                                          className=" input-group  rounded bg-light"
                                          
                                          style={{ marginTop: "3px"}}
                                        >
                                          <Label className="form-label"></Label>
                                          <Field
                                            style={{ fontSize: "13px", color: "black" }}
                                            type="text"
                                            name="clientId"
                                            readOnly={true}
                                            className="form-control bg-transparent "
                                            placeholder={this.props.t("clientId")}
                                          />
                                          <button
                                            name="btnname"
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={() => this.handleGenerateClientId(values,setFieldValue,false)}
                                          >
                                            {this.props.t("generateClientId")}
                                          </button>
                                        </div>
                                      </Col>
                                      <Col lg={12} className="col-12" style={{ marginTop: "3px",display: displayNone(internalUser)}}>
                                        <p>{""}</p>
                                        <div
                                          className=" input-group  rounded bg-light"
                                          style={{ marginTop: "3px"}}
                                        >
                                          <Label className="form-label"></Label>
                                          <Field
                                            style={{ fontSize: "13px", color: "black" }}
                                            type="text"
                                            name="clientSecret"
                                            readOnly={true}
                                            className="form-control bg-transparent "
                                            placeholder={this.props.t("clientSecret")}
                                          />
                                          <button
                                            name="btnname"
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={() => this.handleGenerateClientSecret(values,setFieldValue)}
                                          >
                                            {this.props.t("generateClientSecret")}
                                          </button>
                                        </div>
                                      </Col>
                                    </Row>

                                  </div>
                                  </div>
                                  <Col lg={12} className="col-12">
                                    <p>{""}</p>
                                    <div
                                      className=" input-group  rounded bg-light"
                                      style={{ marginTop: "3px" }}
                                    >
                                      <Label className="form-label"></Label>
                                      <Field
                                        style={{ fontSize: "13px", color: "black" }}
                                        type="text"
                                        name="password"
                                        readOnly={true}
                                        className="form-control bg-transparent "
                                        placeholder={this.props.t("password")}
                                      />
                                      <button
                                        name="btnname"
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={() => this.handleGeneratePassword(setFieldValue)}
                                      >
                                        {this.props.t("generatePassword")}
                                      </button>
                                    </div>
                                  </Col>
                                  <Col lg={12}>
                                    <p>{""}</p>
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"systemUserStatusDefinitionGuid"}
                                        label={"userStatusDefGuid"}
                                        component="multiselect"
                                        type="singleselect"
                                        valueList={this.props.userStatusDefList}
                                        nameOnValueList={[
                                          "name"
                                        ]}
                                        disabled={this.state.isDetail}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={12} className="col-12">
                                    <div className="mb-3">
                                      <RavenFormikField
                                        errors={errors}
                                        touched={touched}
                                        name={"address"}
                                        label={"address"}
                                        type="textarea"
                                        rows={3}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </fieldset>
                              <ModalHeader
                                style={{ marginTop: "-30px", marginBottom: "10px" }}
                              ></ModalHeader>
                              <PageModalFooter
                                isEdit={this.state.isEdit}
                                isDetail={this.state.isDetail}
                                onCheckboxClick={() => { this.setState({ addAnother: !this.state.addAnother }); }}
                                onCancelClick={() => this.toggle()}
                                id="customSwitchsizelgDetail"
                                defaultChecked={this.state.addAnother}
                              />
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

userDefinition.propTypes = {
  recordList: PropTypes.array,
  onGetRecordList: PropTypes.func,
  onAddRecord: PropTypes.func,
  onUpdateRecord: PropTypes.func,
  onDeleteRecord: PropTypes.func,
  userStatusDefList: PropTypes.array,
  onGetUserStatusList: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
};

const mapStateToProps = ({ UserDefinition, userStatusDef }) => ({
  recordList: UserDefinition.userDefinitions,
  userStatusDefList: userStatusDef.userStatusDefinitions,
  error: UserDefinition.error,
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList: userName => dispatch(getUserDefinitionsByUserName(userName)),
  onAddRecord: record => dispatch(addNewUserDefinition(record)),
  onUpdateRecord: record => dispatch(updateUserDefinition(record)),
  onDeleteRecord: guid => dispatch(deleteUserDefinition(guid)),
  onGetUserStatusList: () => dispatch(getUserStatusDefinitions()),
  apiError: error => dispatch(userDefinitionsApiError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(userDefinition));
